if (!customElements.get('random-product-picker')) {
  customElements.define(
    'random-product-picker',
    class RandomProductPicker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mode !== 'random') return;

        const items = Array.from(this.querySelectorAll('.grid__item'));
        const showCount = parseInt(this.dataset.showCount, 10) || 4;

        for (let i = items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const temp = items[i];
          items[i] = items[j];
          items[j] = temp;
        }

        items.forEach((item, index) => {
          item.style.display = index < showCount ? '' : 'none';
        });
      }
    }
  );
}